/**
 * Capitalizes the first character of a string, leaving the rest untouched.
 *
 * @param value - The string to transform
 * @returns The string with its first character upper-cased
 *
 * @example
 * toSentenceCase('tomato') // 'Tomato'
 * toSentenceCase('') // ''
 */
export const toSentenceCase = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);
